import type { Configuration } from '../types/configuration/Configuration'

export async function loadConfigurationAsync(): Promise<Configuration | null> {
  try {
    const response = await fetch('/config.json')
    const file = await response.json()
    return file as Configuration
  } catch (exception: any) {
    return null
  }
}
